import AbmAutoCheckIn from "../../components/textos/AbmAutoCheckIn/AbmAutoCheckIn";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/20?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmAutoCheckIn,
    textSize: 10
}